import { render } from "./DeleteEntitlements.vue?vue&type=template&id=47eb9787"
import script from "./DeleteEntitlements.vue?vue&type=script&lang=js"
export * from "./DeleteEntitlements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__